import { render, staticRenderFns } from "./LabelCol.vue?vue&type=template&id=af3953a8"
import script from "./LabelCol.vue?vue&type=script&lang=js"
export * from "./LabelCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports